export default __webpack_public_path__ + "static/img/vogue_scene_animated_0633.1a34eb9.webp";